import React from 'react';

import PropTypes from 'prop-types';

import { AllBooksIcon } from 'rebook/apps/base/components/icons/BookIconTransparent';

import styles from './style.scss';


const EmptyBookList = ({ noOneSelect }) => (
  <div className={styles.emptyBookList}>
    <AllBooksIcon />
    <span
      className={styles.emptyBookListText}>
      {noOneSelect ? 'Вы пока ничего не выбрали' : 'Вы не выбрали ни одного фильтра'}

    </span>
  </div>
);

EmptyBookList.propTypes = {
  noOneSelect: PropTypes.bool,
};

EmptyBookList.defaultProps = {
  noOneSelect: false,

};

export default EmptyBookList;
